import SmartSelector from "@/Layouts/components/InputComponents/SmartSelector";
import { TSelectValue } from "@/Layouts/components/InputComponents/SmartSelector/interfaces";
import { GridApiPremium } from "@mui/x-data-grid-premium/models/gridApiPremium";

interface IInputEditSelectorCellProps {
	id: string;
	field: string;
	error: boolean;
	tableApiRef: React.MutableRefObject<GridApiPremium>;
	options: TSelectValue[];
	value: TSelectValue;
	multiple?: boolean;
	multipleSelectAll?: boolean;
	popperProps?: object;
	placeholder?: string;
	inputClasses?: string;
	onOpenAction?: () => void;
	onCloseAction?: () => void;
}

const InputEditSelectorCell = (props: IInputEditSelectorCellProps) => {
	const {
		id,
		field,
		error,
		tableApiRef,
		multiple = false,
		multipleSelectAll = false,
		placeholder,
		popperProps,
		inputClasses = "",
		onOpenAction,
		onCloseAction,
	} = props;

	const handleChange = (value: TSelectValue) => {
		if (Array.isArray(value)) {
			const updatedSelectedValues = value.filter((v) => "label" in v).map((v) => v.label);
			// `debounceMs` is important to avoid the input to be updated too often.
			tableApiRef.current.setEditCellValue({ id, field, value: updatedSelectedValues, debounceMs: 200 });
		} else if (value && "label" in value) {
			// `debounceMs` is important to avoid the input to be updated too often.
			tableApiRef.current.setEditCellValue({ id, field, value: value.label, debounceMs: 200 });
		}
	};

	const getSelectedValues = (value: TSelectValue) => {
		if (Array.isArray(value)) {
			return value.map((v) => ({ label: v }));
		}
		return value;
	};

	const handleOnOpenAction = () => {
		if (!onOpenAction) {
			return;
		}
		onOpenAction();
	};

	const handleOnCloseAction = () => {
		if (!onCloseAction) {
			return;
		}
		onCloseAction();
	};

	return (
		<SmartSelector
			addable={false}
			tagsVariant="text"
			showBy="label"
			selectBy={"label"}
			options={props.options.filter((option) => option !== null)}
			selected={getSelectedValues(props.value)}
			multiple={multiple}
			multipleSelectAll={multipleSelectAll}
			inputProps={{
				placeholder,
				classes: `[&_.MuiInputBase-root]:!min-h-[26px] [&_.MuiInputBase-root]:!py-[3px] [&_.MuiInputBase-root_.MuiInputBase-input]:!rounded-none ${inputClasses}`,
			}}
			popperProps={popperProps}
			error={error || !props.value}
			onChangeAction={handleChange}
			onOpenAction={handleOnOpenAction}
			onCloseAction={handleOnCloseAction}
		/>
	);
};

export default InputEditSelectorCell;
